module.exports = __webpack_public_path__ + "img/BKK.5cb52ac9.png";